import { render, staticRenderFns } from "./BgClassSelector.vue?vue&type=template&id=55756f11&"
import script from "./BgClassSelector.vue?vue&type=script&lang=js&"
export * from "./BgClassSelector.vue?vue&type=script&lang=js&"
import style0 from "./BgClassSelector.vue?vue&type=style&index=0&id=55756f11&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports